import { createElementBlock as t, openBlock as l, createElementVNode as n } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(d, e) {
  return l(), t("svg", o, e[0] || (e[0] = [
    n("path", {
      fill: "#fff",
      "fill-rule": "evenodd",
      d: "M12.568 9.748C9.495 9.532 2.529 10.934 2.529 14c0 2 3.688 4.923 9.696 5 .237 0 7.061-.256 6.956-7.385-.089-5.986-4.693-7.035-6.166-7.218v-.365C18.885 4.394 23.5 7.832 23.5 12 23.5 16.41 18.337 20 11.987 20S.5 16.41.5 12s5.138-8 11.487-8q.292 0 .58.01zm0 .16v8.58s-5.113-.899-5.113-4.308c0-2.72 3.785-3.92 5.113-4.271",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const c = { render: r };
export {
  c as default,
  r as render
};
//# sourceMappingURL=ic_payment_debit_light-BMSiUwFa.js.map
